import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "newAddressModalRef",
  id: "kt_modal_new_address",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Add New Address", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_address_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_address_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_address_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_11 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, "Warning"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createTextVNode(" Updating address may affter to your "),
      /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Tax Location")
    ])
  ])
], -1)
const _hoisted_13 = { class: "row mb-5" }
const _hoisted_14 = { class: "col-md-6 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "First name", -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "col-md-6 fv-row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Last name", -1)
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Country"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Your payment statements may very based on selected country"
  })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a Country...", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "AF" }, "Afghanistan", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "AX" }, "Aland Islands", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "AL" }, "Albania", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "DZ" }, "Algeria", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "AS" }, "American Samoa", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "AD" }, "Andorra", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "AO" }, "Angola", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "AI" }, "Anguilla", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "AQ" }, "Antarctica", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "AG" }, "Antigua and Barbuda", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "AR" }, "Argentina", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "AM" }, "Armenia", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: "AW" }, "Aruba", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: "AU" }, "Australia", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "AT" }, "Austria", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "AZ" }, "Azerbaijan", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "BS" }, "Bahamas", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: "BH" }, "Bahrain", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "BD" }, "Bangladesh", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "BB" }, "Barbados", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "BY" }, "Belarus", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "BE" }, "Belgium", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "BZ" }, "Belize", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: "BJ" }, "Benin", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: "BM" }, "Bermuda", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("option", { value: "BT" }, "Bhutan", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { value: "BO" }, "Bolivia, Plurinational State of", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "BQ" }, "Bonaire, Sint Eustatius and Saba", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", { value: "BA" }, "Bosnia and Herzegovina", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: "BW" }, "Botswana", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", { value: "BV" }, "Bouvet Island", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "BR" }, "Brazil", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "IO" }, "British Indian Ocean Territory", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "BN" }, "Brunei Darussalam", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "BG" }, "Bulgaria", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "BF" }, "Burkina Faso", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("option", { value: "BI" }, "Burundi", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: "KH" }, "Cambodia", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("option", { value: "CM" }, "Cameroon", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("option", { value: "CA" }, "Canada", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("option", { value: "CV" }, "Cape Verde", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("option", { value: "KY" }, "Cayman Islands", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", { value: "CF" }, "Central African Republic", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", { value: "TD" }, "Chad", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", { value: "CL" }, "Chile", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("option", { value: "CN" }, "China", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", { value: "CX" }, "Christmas Island", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("option", { value: "CC" }, "Cocos (Keeling) Islands", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("option", { value: "CO" }, "Colombia", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", { value: "KM" }, "Comoros", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("option", { value: "CG" }, "Congo", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("option", { value: "CD" }, " Congo, the Democratic Republic of the ", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("option", { value: "CK" }, "Cook Islands", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("option", { value: "CR" }, "Costa Rica", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("option", { value: "CI" }, "Côte d'Ivoire", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("option", { value: "HR" }, "Croatia", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("option", { value: "CU" }, "Cuba", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("option", { value: "CW" }, "Curaçao", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("option", { value: "CY" }, "Cyprus", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("option", { value: "CZ" }, "Czech Republic", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("option", { value: "DK" }, "Denmark", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("option", { value: "DJ" }, "Djibouti", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("option", { value: "DM" }, "Dominica", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("option", { value: "DO" }, "Dominican Republic", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("option", { value: "EC" }, "Ecuador", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("option", { value: "EG" }, "Egypt", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("option", { value: "SV" }, "El Salvador", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("option", { value: "GQ" }, "Equatorial Guinea", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("option", { value: "ER" }, "Eritrea", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("option", { value: "EE" }, "Estonia", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", { value: "ET" }, "Ethiopia", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("option", { value: "FK" }, "Falkland Islands (Malvinas)", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("option", { value: "FO" }, "Faroe Islands", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("option", { value: "FJ" }, "Fiji", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("option", { value: "FI" }, "Finland", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("option", { value: "FR" }, "France", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("option", { value: "GF" }, "French Guiana", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("option", { value: "PF" }, "French Polynesia", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", { value: "TF" }, "French Southern Territories", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("option", { value: "GA" }, "Gabon", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("option", { value: "GM" }, "Gambia", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", { value: "GE" }, "Georgia", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("option", { value: "DE" }, "Germany", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("option", { value: "GH" }, "Ghana", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("option", { value: "GI" }, "Gibraltar", -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("option", { value: "GR" }, "Greece", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("option", { value: "GL" }, "Greenland", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("option", { value: "GD" }, "Grenada", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("option", { value: "GP" }, "Guadeloupe", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("option", { value: "GU" }, "Guam", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("option", { value: "GT" }, "Guatemala", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("option", { value: "GG" }, "Guernsey", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("option", { value: "GN" }, "Guinea", -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("option", { value: "GW" }, "Guinea-Bissau", -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("option", { value: "GY" }, "Guyana", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("option", { value: "HT" }, "Haiti", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("option", { value: "HM" }, "Heard Island and McDonald Islands", -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("option", { value: "VA" }, "Holy See (Vatican City State)", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("option", { value: "HN" }, "Honduras", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("option", { value: "HK" }, "Hong Kong", -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("option", { value: "HU" }, "Hungary", -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("option", { value: "IS" }, "Iceland", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("option", { value: "IN" }, "India", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("option", { value: "ID" }, "Indonesia", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("option", { value: "IR" }, "Iran, Islamic Republic of", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("option", { value: "IQ" }, "Iraq", -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("option", { value: "IE" }, "Ireland", -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("option", { value: "IM" }, "Isle of Man", -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("option", { value: "IL" }, "Israel", -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("option", { value: "IT" }, "Italy", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("option", { value: "JM" }, "Jamaica", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("option", { value: "JP" }, "Japan", -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("option", { value: "JE" }, "Jersey", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("option", { value: "JO" }, "Jordan", -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("option", { value: "KZ" }, "Kazakhstan", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("option", { value: "KE" }, "Kenya", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("option", { ue: "KI" }, "Kiribati", -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("option", { value: "KP" }, " Korea, Democratic People's Republic of ", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("option", { value: "KW" }, "Kuwait", -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("option", { value: "KG" }, "Kyrgyzstan", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("option", { value: "LA" }, "Lao People's Democratic Republic", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("option", { value: "LV" }, "Latvia", -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("option", { value: "LB" }, "Lebanon", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("option", { value: "LS" }, "Lesotho", -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("option", { value: "LR" }, "Liberia", -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("option", { value: "LY" }, "Libya", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("option", { value: "LI" }, "Liechtenstein", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("option", { value: "LT" }, "Lithuania", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("option", { value: "LU" }, "Luxembourg", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("option", { value: "MO" }, "Macao", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("option", { value: "MK" }, " Macedonia, the former Yugoslav Republic of ", -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("option", { value: "MG" }, "Madagascar", -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("option", { value: "MW" }, "Malawi", -1)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("option", { value: "MY" }, "Malaysia", -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("option", { value: "MV" }, "Maldives", -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("option", { value: "ML" }, "Mali", -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("option", { value: "MT" }, "Malta", -1)
const _hoisted_162 = /*#__PURE__*/_createElementVNode("option", { value: "MH" }, "Marshall Islands", -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("option", { value: "MQ" }, "Martinique", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("option", { value: "MR" }, "Mauritania", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("option", { value: "MU" }, "Mauritius", -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("option", { value: "YT" }, "Mayotte", -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("option", { value: "MX" }, "Mexico", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("option", { value: "FM" }, "Micronesia, Federated States of", -1)
const _hoisted_169 = /*#__PURE__*/_createElementVNode("option", { value: "MD" }, "Moldova, Republic of", -1)
const _hoisted_170 = /*#__PURE__*/_createElementVNode("option", { value: "MC" }, "Monaco", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("option", { value: "MN" }, "Mongolia", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("option", { value: "ME" }, "Montenegro", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("option", { value: "MS" }, "Montserrat", -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("option", { value: "MA" }, "Morocco", -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("option", { value: "MZ" }, "Mozambique", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("option", { value: "MM" }, "Myanmar", -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("option", { value: "NA" }, "Namibia", -1)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("option", { value: "NR" }, "Nauru", -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("option", { value: "NP" }, "Nepal", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("option", { value: "NL" }, "Netherlands", -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("option", { value: "NC" }, "New Caledonia", -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("option", { value: "NZ" }, "New Zealand", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("option", { value: "NI" }, "Nicaragua", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("option", { value: "NE" }, "Niger", -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("option", { value: "NG" }, "Nigeria", -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("option", { value: "NU" }, "Niue", -1)
const _hoisted_187 = /*#__PURE__*/_createElementVNode("option", { value: "NF" }, "Norfolk Island", -1)
const _hoisted_188 = /*#__PURE__*/_createElementVNode("option", { value: "MP" }, "Northern Mariana Islands", -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("option", { value: "NO" }, "Norway", -1)
const _hoisted_190 = /*#__PURE__*/_createElementVNode("option", { value: "OM" }, "Oman", -1)
const _hoisted_191 = /*#__PURE__*/_createElementVNode("option", { value: "PK" }, "Pakistan", -1)
const _hoisted_192 = /*#__PURE__*/_createElementVNode("option", { value: "PW" }, "Palau", -1)
const _hoisted_193 = /*#__PURE__*/_createElementVNode("option", { value: "PS" }, "Palestinian Territory, Occupied", -1)
const _hoisted_194 = /*#__PURE__*/_createElementVNode("option", { value: "PA" }, "Panama", -1)
const _hoisted_195 = /*#__PURE__*/_createElementVNode("option", { value: "PG" }, "Papua New Guinea", -1)
const _hoisted_196 = /*#__PURE__*/_createElementVNode("option", { value: "PY" }, "Paraguay", -1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("option", { value: "PE" }, "Peru", -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("option", { value: "PH" }, "Philippines", -1)
const _hoisted_199 = /*#__PURE__*/_createElementVNode("option", { value: "PN" }, "Pitcairn", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("option", { value: "PL" }, "Poland", -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("option", { value: "PT" }, "Portugal", -1)
const _hoisted_202 = /*#__PURE__*/_createElementVNode("option", { value: "PR" }, "Puerto Rico", -1)
const _hoisted_203 = /*#__PURE__*/_createElementVNode("option", { value: "QA" }, "Qatar", -1)
const _hoisted_204 = /*#__PURE__*/_createElementVNode("option", { value: "RE" }, "Réunion", -1)
const _hoisted_205 = /*#__PURE__*/_createElementVNode("option", { value: "RO" }, "Romania", -1)
const _hoisted_206 = /*#__PURE__*/_createElementVNode("option", { value: "RU" }, "Russian Federation", -1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("option", { value: "RW" }, "Rwanda", -1)
const _hoisted_208 = /*#__PURE__*/_createElementVNode("option", { value: "BL" }, "Saint Barthélemy", -1)
const _hoisted_209 = /*#__PURE__*/_createElementVNode("option", { value: "SH" }, " Saint Helena, Ascension and Tristan da Cunha ", -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("option", { value: "KN" }, "Saint Kitts and Nevis", -1)
const _hoisted_211 = /*#__PURE__*/_createElementVNode("option", { value: "LC" }, "Saint Lucia", -1)
const _hoisted_212 = /*#__PURE__*/_createElementVNode("option", { value: "MF" }, "Saint Martin (French part)", -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("option", { value: "PM" }, "Saint Pierre and Miquelon", -1)
const _hoisted_214 = /*#__PURE__*/_createElementVNode("option", { value: "VC" }, "Saint Vincent and the Grenadines", -1)
const _hoisted_215 = /*#__PURE__*/_createElementVNode("option", { value: "WS" }, "Samoa", -1)
const _hoisted_216 = /*#__PURE__*/_createElementVNode("option", { value: "SM" }, "San Marino", -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("option", { value: "ST" }, "Sao Tome and Principe", -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("option", { value: "SA" }, "Saudi Arabia", -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("option", { value: "SN" }, "Senegal", -1)
const _hoisted_220 = /*#__PURE__*/_createElementVNode("option", { value: "RS" }, "Serbia", -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("option", { value: "SC" }, "Seychelles", -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("option", { value: "SL" }, "Sierra Leone", -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("option", { value: "SG" }, "Singapore", -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("option", { value: "SX" }, "Sint Maarten (Dutch part)", -1)
const _hoisted_225 = /*#__PURE__*/_createElementVNode("option", { value: "SK" }, "Slovakia", -1)
const _hoisted_226 = /*#__PURE__*/_createElementVNode("option", { value: "SI" }, "Slovenia", -1)
const _hoisted_227 = /*#__PURE__*/_createElementVNode("option", { value: "SB" }, "Solomon Islands", -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("option", { value: "SO" }, "Somalia", -1)
const _hoisted_229 = /*#__PURE__*/_createElementVNode("option", { value: "ZA" }, "South Africa", -1)
const _hoisted_230 = /*#__PURE__*/_createElementVNode("option", { value: "GS" }, " South Georgia and the South Sandwich Islands ", -1)
const _hoisted_231 = /*#__PURE__*/_createElementVNode("option", { value: "KR" }, "South Korea", -1)
const _hoisted_232 = /*#__PURE__*/_createElementVNode("option", { value: "SS" }, "South Sudan", -1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("option", { value: "ES" }, "Spain", -1)
const _hoisted_234 = /*#__PURE__*/_createElementVNode("option", { value: "LK" }, "Sri Lanka", -1)
const _hoisted_235 = /*#__PURE__*/_createElementVNode("option", { value: "SD" }, "Sudan", -1)
const _hoisted_236 = /*#__PURE__*/_createElementVNode("option", { value: "SR" }, "Suriname", -1)
const _hoisted_237 = /*#__PURE__*/_createElementVNode("option", { value: "SJ" }, "Svalbard and Jan Mayen", -1)
const _hoisted_238 = /*#__PURE__*/_createElementVNode("option", { value: "SZ" }, "Swaziland", -1)
const _hoisted_239 = /*#__PURE__*/_createElementVNode("option", { value: "SE" }, "Sweden", -1)
const _hoisted_240 = /*#__PURE__*/_createElementVNode("option", { value: "CH" }, "Switzerland", -1)
const _hoisted_241 = /*#__PURE__*/_createElementVNode("option", { value: "SY" }, "Syrian Arab Republic", -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("option", { value: "TW" }, "Taiwan, Province of China", -1)
const _hoisted_243 = /*#__PURE__*/_createElementVNode("option", { value: "TJ" }, "Tajikistan", -1)
const _hoisted_244 = /*#__PURE__*/_createElementVNode("option", { value: "TZ" }, "Tanzania, United Republic of", -1)
const _hoisted_245 = /*#__PURE__*/_createElementVNode("option", { value: "TH" }, "Thailand", -1)
const _hoisted_246 = /*#__PURE__*/_createElementVNode("option", { value: "TL" }, "Timor-Leste", -1)
const _hoisted_247 = /*#__PURE__*/_createElementVNode("option", { value: "TG" }, "Togo", -1)
const _hoisted_248 = /*#__PURE__*/_createElementVNode("option", { value: "TK" }, "Tokelau", -1)
const _hoisted_249 = /*#__PURE__*/_createElementVNode("option", { value: "TO" }, "Tonga", -1)
const _hoisted_250 = /*#__PURE__*/_createElementVNode("option", { value: "TT" }, "Trinidad and Tobago", -1)
const _hoisted_251 = /*#__PURE__*/_createElementVNode("option", { value: "TN" }, "Tunisia", -1)
const _hoisted_252 = /*#__PURE__*/_createElementVNode("option", { value: "TR" }, "Turkey", -1)
const _hoisted_253 = /*#__PURE__*/_createElementVNode("option", { value: "TM" }, "Turkmenistan", -1)
const _hoisted_254 = /*#__PURE__*/_createElementVNode("option", { value: "TC" }, "Turks and Caicos Islands", -1)
const _hoisted_255 = /*#__PURE__*/_createElementVNode("option", { value: "TV" }, "Tuvalu", -1)
const _hoisted_256 = /*#__PURE__*/_createElementVNode("option", { value: "UG" }, "Uganda", -1)
const _hoisted_257 = /*#__PURE__*/_createElementVNode("option", { value: "UA" }, "Ukraine", -1)
const _hoisted_258 = /*#__PURE__*/_createElementVNode("option", { value: "AE" }, "United Arab Emirates", -1)
const _hoisted_259 = /*#__PURE__*/_createElementVNode("option", { value: "GB" }, "United Kingdom", -1)
const _hoisted_260 = /*#__PURE__*/_createElementVNode("option", { value: "US" }, "United States", -1)
const _hoisted_261 = /*#__PURE__*/_createElementVNode("option", { value: "UY" }, "Uruguay", -1)
const _hoisted_262 = /*#__PURE__*/_createElementVNode("option", { value: "UZ" }, "Uzbekistan", -1)
const _hoisted_263 = /*#__PURE__*/_createElementVNode("option", { value: "VU" }, "Vanuatu", -1)
const _hoisted_264 = /*#__PURE__*/_createElementVNode("option", { value: "VE" }, "Venezuela, Bolivarian Republic of", -1)
const _hoisted_265 = /*#__PURE__*/_createElementVNode("option", { value: "VN" }, "Vietnam", -1)
const _hoisted_266 = /*#__PURE__*/_createElementVNode("option", { value: "VI" }, "Virgin Islands", -1)
const _hoisted_267 = /*#__PURE__*/_createElementVNode("option", { value: "WF" }, "Wallis and Futuna", -1)
const _hoisted_268 = /*#__PURE__*/_createElementVNode("option", { value: "EH" }, "Western Sahara", -1)
const _hoisted_269 = /*#__PURE__*/_createElementVNode("option", { value: "YE" }, "Yemen", -1)
const _hoisted_270 = /*#__PURE__*/_createElementVNode("option", { value: "ZM" }, "Zambia", -1)
const _hoisted_271 = /*#__PURE__*/_createElementVNode("option", { value: "ZW" }, "Zimbabwe", -1)
const _hoisted_272 = { class: "fv-plugins-message-container" }
const _hoisted_273 = { class: "fv-help-block" }
const _hoisted_274 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Address Line 1", -1)
const _hoisted_276 = { class: "fv-plugins-message-container" }
const _hoisted_277 = { class: "fv-help-block" }
const _hoisted_278 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_279 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Address Line 2", -1)
const _hoisted_280 = { class: "fv-plugins-message-container" }
const _hoisted_281 = { class: "fv-help-block" }
const _hoisted_282 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_283 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Town", -1)
const _hoisted_284 = { class: "fv-plugins-message-container" }
const _hoisted_285 = { class: "fv-help-block" }
const _hoisted_286 = { class: "row g-9 mb-5" }
const _hoisted_287 = { class: "col-md-6 fv-row" }
const _hoisted_288 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "State / Province", -1)
const _hoisted_289 = { class: "fv-plugins-message-container" }
const _hoisted_290 = { class: "fv-help-block" }
const _hoisted_291 = { class: "col-md-6 fv-row" }
const _hoisted_292 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Post Code", -1)
const _hoisted_293 = { class: "fv-plugins-message-container" }
const _hoisted_294 = { class: "fv-help-block" }
const _hoisted_295 = { class: "fv-row mb-5" }
const _hoisted_296 = { class: "d-flex flex-stack" }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold" }, "Use as a billing adderess?"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " If you need more info, please check budget planning ")
], -1)
const _hoisted_298 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_299 = { class: "fv-plugins-message-container" }
const _hoisted_300 = { class: "fv-help-block" }
const _hoisted_301 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-400" }, " Yes ", -1)
const _hoisted_302 = { class: "modal-footer flex-center" }
const _hoisted_303 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_new_address_cancel",
  class: "btn btn-white me-3"
}, " Discard ", -1)
const _hoisted_304 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_address_submit",
  class: "btn btn-dark-blue"
}
const _hoisted_305 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_306 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_307 = [
  _hoisted_305,
  _hoisted_306
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_address_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, {
                    src: "/media/icons/duotune/arrows/arr061.svg",
                    "aria-hidden": "true"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, {
                      src: "/media/icons/duotune/general/gen044.svg",
                      "aria-hidden": "true"
                    })
                  ]),
                  _hoisted_12
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control",
                      placeholder: "",
                      name: "firstName",
                      modelValue: _ctx.newAddressData.firstName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newAddressData.firstName) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "firstName" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control",
                      placeholder: "",
                      name: "lastName",
                      modelValue: _ctx.newAddressData.lastName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newAddressData.lastName) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "lastName" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_Field, {
                    name: "country",
                    class: "form-select form-select-solid",
                    as: "select",
                    modelValue: _ctx.newAddressData.country,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newAddressData.country) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _hoisted_44,
                      _hoisted_45,
                      _hoisted_46,
                      _hoisted_47,
                      _hoisted_48,
                      _hoisted_49,
                      _hoisted_50,
                      _hoisted_51,
                      _hoisted_52,
                      _hoisted_53,
                      _hoisted_54,
                      _hoisted_55,
                      _hoisted_56,
                      _hoisted_57,
                      _hoisted_58,
                      _hoisted_59,
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62,
                      _hoisted_63,
                      _hoisted_64,
                      _hoisted_65,
                      _hoisted_66,
                      _hoisted_67,
                      _hoisted_68,
                      _hoisted_69,
                      _hoisted_70,
                      _hoisted_71,
                      _hoisted_72,
                      _hoisted_73,
                      _hoisted_74,
                      _hoisted_75,
                      _hoisted_76,
                      _hoisted_77,
                      _hoisted_78,
                      _hoisted_79,
                      _hoisted_80,
                      _hoisted_81,
                      _hoisted_82,
                      _hoisted_83,
                      _hoisted_84,
                      _hoisted_85,
                      _hoisted_86,
                      _hoisted_87,
                      _hoisted_88,
                      _hoisted_89,
                      _hoisted_90,
                      _hoisted_91,
                      _hoisted_92,
                      _hoisted_93,
                      _hoisted_94,
                      _hoisted_95,
                      _hoisted_96,
                      _hoisted_97,
                      _hoisted_98,
                      _hoisted_99,
                      _hoisted_100,
                      _hoisted_101,
                      _hoisted_102,
                      _hoisted_103,
                      _hoisted_104,
                      _hoisted_105,
                      _hoisted_106,
                      _hoisted_107,
                      _hoisted_108,
                      _hoisted_109,
                      _hoisted_110,
                      _hoisted_111,
                      _hoisted_112,
                      _hoisted_113,
                      _hoisted_114,
                      _hoisted_115,
                      _hoisted_116,
                      _hoisted_117,
                      _hoisted_118,
                      _hoisted_119,
                      _hoisted_120,
                      _hoisted_121,
                      _hoisted_122,
                      _hoisted_123,
                      _hoisted_124,
                      _hoisted_125,
                      _hoisted_126,
                      _hoisted_127,
                      _hoisted_128,
                      _hoisted_129,
                      _hoisted_130,
                      _hoisted_131,
                      _hoisted_132,
                      _hoisted_133,
                      _hoisted_134,
                      _hoisted_135,
                      _hoisted_136,
                      _hoisted_137,
                      _hoisted_138,
                      _hoisted_139,
                      _hoisted_140,
                      _hoisted_141,
                      _hoisted_142,
                      _hoisted_143,
                      _hoisted_144,
                      _hoisted_145,
                      _hoisted_146,
                      _hoisted_147,
                      _hoisted_148,
                      _hoisted_149,
                      _hoisted_150,
                      _hoisted_151,
                      _hoisted_152,
                      _hoisted_153,
                      _hoisted_154,
                      _hoisted_155,
                      _hoisted_156,
                      _hoisted_157,
                      _hoisted_158,
                      _hoisted_159,
                      _hoisted_160,
                      _hoisted_161,
                      _hoisted_162,
                      _hoisted_163,
                      _hoisted_164,
                      _hoisted_165,
                      _hoisted_166,
                      _hoisted_167,
                      _hoisted_168,
                      _hoisted_169,
                      _hoisted_170,
                      _hoisted_171,
                      _hoisted_172,
                      _hoisted_173,
                      _hoisted_174,
                      _hoisted_175,
                      _hoisted_176,
                      _hoisted_177,
                      _hoisted_178,
                      _hoisted_179,
                      _hoisted_180,
                      _hoisted_181,
                      _hoisted_182,
                      _hoisted_183,
                      _hoisted_184,
                      _hoisted_185,
                      _hoisted_186,
                      _hoisted_187,
                      _hoisted_188,
                      _hoisted_189,
                      _hoisted_190,
                      _hoisted_191,
                      _hoisted_192,
                      _hoisted_193,
                      _hoisted_194,
                      _hoisted_195,
                      _hoisted_196,
                      _hoisted_197,
                      _hoisted_198,
                      _hoisted_199,
                      _hoisted_200,
                      _hoisted_201,
                      _hoisted_202,
                      _hoisted_203,
                      _hoisted_204,
                      _hoisted_205,
                      _hoisted_206,
                      _hoisted_207,
                      _hoisted_208,
                      _hoisted_209,
                      _hoisted_210,
                      _hoisted_211,
                      _hoisted_212,
                      _hoisted_213,
                      _hoisted_214,
                      _hoisted_215,
                      _hoisted_216,
                      _hoisted_217,
                      _hoisted_218,
                      _hoisted_219,
                      _hoisted_220,
                      _hoisted_221,
                      _hoisted_222,
                      _hoisted_223,
                      _hoisted_224,
                      _hoisted_225,
                      _hoisted_226,
                      _hoisted_227,
                      _hoisted_228,
                      _hoisted_229,
                      _hoisted_230,
                      _hoisted_231,
                      _hoisted_232,
                      _hoisted_233,
                      _hoisted_234,
                      _hoisted_235,
                      _hoisted_236,
                      _hoisted_237,
                      _hoisted_238,
                      _hoisted_239,
                      _hoisted_240,
                      _hoisted_241,
                      _hoisted_242,
                      _hoisted_243,
                      _hoisted_244,
                      _hoisted_245,
                      _hoisted_246,
                      _hoisted_247,
                      _hoisted_248,
                      _hoisted_249,
                      _hoisted_250,
                      _hoisted_251,
                      _hoisted_252,
                      _hoisted_253,
                      _hoisted_254,
                      _hoisted_255,
                      _hoisted_256,
                      _hoisted_257,
                      _hoisted_258,
                      _hoisted_259,
                      _hoisted_260,
                      _hoisted_261,
                      _hoisted_262,
                      _hoisted_263,
                      _hoisted_264,
                      _hoisted_265,
                      _hoisted_266,
                      _hoisted_267,
                      _hoisted_268,
                      _hoisted_269,
                      _hoisted_270,
                      _hoisted_271
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_272, [
                    _createElementVNode("div", _hoisted_273, [
                      _createVNode(_component_ErrorMessage, { name: "country" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_274, [
                  _hoisted_275,
                  _createVNode(_component_Field, {
                    class: "form-control",
                    placeholder: "",
                    name: "address1",
                    modelValue: _ctx.newAddressData.address1,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newAddressData.address1) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_276, [
                    _createElementVNode("div", _hoisted_277, [
                      _createVNode(_component_ErrorMessage, { name: "address1" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_278, [
                  _hoisted_279,
                  _createVNode(_component_Field, {
                    class: "form-control",
                    placeholder: "",
                    name: "address2",
                    modelValue: _ctx.newAddressData.address2,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newAddressData.address2) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_280, [
                    _createElementVNode("div", _hoisted_281, [
                      _createVNode(_component_ErrorMessage, { name: "address2" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_282, [
                  _hoisted_283,
                  _createVNode(_component_Field, {
                    class: "form-control",
                    placeholder: "",
                    name: "town",
                    modelValue: _ctx.newAddressData.town,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newAddressData.town) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_284, [
                    _createElementVNode("div", _hoisted_285, [
                      _createVNode(_component_ErrorMessage, { name: "town" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_286, [
                  _createElementVNode("div", _hoisted_287, [
                    _hoisted_288,
                    _createVNode(_component_Field, {
                      class: "form-control",
                      placeholder: "",
                      name: "state",
                      modelValue: _ctx.newAddressData.state,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newAddressData.state) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_289, [
                      _createElementVNode("div", _hoisted_290, [
                        _createVNode(_component_ErrorMessage, { name: "state" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_291, [
                    _hoisted_292,
                    _createVNode(_component_Field, {
                      class: "form-control",
                      placeholder: "",
                      name: "postCode",
                      modelValue: _ctx.newAddressData.postCode,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newAddressData.postCode) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_293, [
                      _createElementVNode("div", _hoisted_294, [
                        _createVNode(_component_ErrorMessage, { name: "postCode" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_295, [
                  _createElementVNode("div", _hoisted_296, [
                    _hoisted_297,
                    _createElementVNode("label", _hoisted_298, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "billing",
                        type: "checkbox",
                        value: "1",
                        checked: "checked"
                      }),
                      _createElementVNode("div", _hoisted_299, [
                        _createElementVNode("div", _hoisted_300, [
                          _createVNode(_component_ErrorMessage, { name: "billing" })
                        ])
                      ]),
                      _hoisted_301
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_302, [
              _hoisted_303,
              _createElementVNode("button", _hoisted_304, _hoisted_307, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}